import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function updateCard(options) {
    const { baseUrl, brandId, country, cardToken, cardHolderName, expiryDateStr, uberToken, clientId, clientSecret } = options;

    invariant(baseUrl, 'baseUrl is a required param of updateCard()');
    invariant(brandId, 'brandId is a required param of updateCard()');
    invariant(country, 'country is a required param of updateCard()');
    invariant(cardToken, 'cardToken is a required param of updateCard()');
    invariant(cardHolderName, 'cardHolderName is a required param of updateCard()');
    invariant(expiryDateStr, 'expiryDateStr is a required param of updateCard()');
    invariant(uberToken, 'uberToken is a required param of updateCard()');
    invariant(clientId, 'clientId is a required param of updateCard()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wallet/card/gps/${cardToken}`;

    const payload = cardHolderName && expiryDateStr ? {
        card: {
            expire_month: parseInt(expiryDateStr.split('/')[0]),
            expire_year: parseInt(expiryDateStr.split('/')[1])
        },
        card_holder: {
            name: cardHolderName
        }
    } : {}

    return labelRequest(
        authenticatedRequest(
            new Request(url, { method: 'PUT', headers: new Headers(headers), body: JSON.stringify(payload) }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'updateCard',
    );
}
